import React, { Fragment } from "react";
import { Form } from "react-bulma-components";
import { useEnumeratedDataTable } from "redux/features/enumeratedDataValues";
import TrimmedInput from "common-frontend/util/trimmedInput";
import SimpleSelect from "util/simpleSelect";

const { Control } = Form;

function GenderComponent({ getValue, setValue, forSummary, RenderField }) {
  const currentGenderId = getValue("gender_id");
  const currentGenderSelfDescription = getValue("gender_self_description");

  const { list: genders, lookup: genderLookup } = useEnumeratedDataTable(
    "genders"
  );

  const currentGender = genderLookup[currentGenderId];

  const setGenderId = (newId) => {
    setValue("gender_id", newId);
    const gender = genderLookup[newId] ?? {};
    if (gender.symbolic_id !== "S") setValue("gender_self_description", null);
  };
  const setGenderSelfDescription = (desc) => {
    setValue("gender_self_description", desc === "" ? null : desc);
  };

  const isSelfDescribed = currentGender && currentGender.symbolic_id === "S";
  const promptSelfDescription =
    isSelfDescribed || currentGenderSelfDescription !== null;

  const valueLookup = { ...genderLookup };
  if (
    forSummary &&
    promptSelfDescription &&
    (currentGenderSelfDescription ?? "") !== ""
  ) {
    valueLookup[currentGender.id] = { ...valueLookup[currentGender.id] };
    valueLookup[currentGender.id].label += ": " + currentGenderSelfDescription;
  }
  return (
    <Fragment>
      <RenderField
        label="Gender"
        question="With which of the following gender descriptions do you most identify?"
        value={currentGenderId}
        valueLookup={valueLookup}
      >
        <SimpleSelect
          currentValue={currentGenderId}
          setValue={setGenderId}
          valueObjects={genders}
          alwaysNumeric
        />
      </RenderField>

      {promptSelfDescription && !forSummary ? (
        <RenderField
          label={null}
          question="Your gender self-description:"
          value={currentGenderSelfDescription}
        >
          <Control>
            <TrimmedInput
              value={currentGenderSelfDescription ?? ""}
              setValue={setGenderSelfDescription}
              disabled={!isSelfDescribed}
              placeholder="Write your gender self-description here"
            />
          </Control>
        </RenderField>
      ) : null}
    </Fragment>
  );
}

export default GenderComponent;
